import { render, staticRenderFns } from "./SideBarNews.vue?vue&type=template&id=4167d9c4&scoped=true"
import script from "./SideBarNews.vue?vue&type=script&lang=js"
export * from "./SideBarNews.vue?vue&type=script&lang=js"
import style0 from "./SideBarNews.vue?vue&type=style&index=0&id=4167d9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4167d9c4",
  null
  
)

export default component.exports